export const CommunityContactDayOfWeeks = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
];
export const formatDayOfWeek = (dayOfWeek) => {
    return dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.slice(1);
};
export const CommunityContactHours = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
];
export const formatHour = (hour) => {
    const hourInt = parseInt(hour);
    const amPm = hourInt >= 12 ? "PM" : "AM";
    const hour12 = hourInt % 12 === 0 ? 12 : hourInt % 12;
    return `${hour12}:00 ${amPm}`;
};
export var ObservationStatus;
(function (ObservationStatus) {
    ObservationStatus["Verified"] = "Verified";
    ObservationStatus["Unverified"] = "Unverified";
})(ObservationStatus || (ObservationStatus = {}));
export var EvergreenCommunityListingDataRequestStatus;
(function (EvergreenCommunityListingDataRequestStatus) {
    EvergreenCommunityListingDataRequestStatus["Pending"] = "Pending";
    EvergreenCommunityListingDataRequestStatus["Completed"] = "Completed";
})(EvergreenCommunityListingDataRequestStatus || (EvergreenCommunityListingDataRequestStatus = {}));
export var EvergreenCommunityListingAvailability;
(function (EvergreenCommunityListingAvailability) {
    EvergreenCommunityListingAvailability["Available"] = "Available";
    EvergreenCommunityListingAvailability["Unavailable"] = "Unavailable";
    EvergreenCommunityListingAvailability["Unknown"] = "Unknown";
})(EvergreenCommunityListingAvailability || (EvergreenCommunityListingAvailability = {}));
export const formatAvailability = (availability) => {
    switch (availability) {
        case EvergreenCommunityListingAvailability.Available:
            return "Yes";
        case EvergreenCommunityListingAvailability.Unavailable:
            return "No";
        case EvergreenCommunityListingAvailability.Unknown:
            return "Unknown";
        default:
            return availability;
    }
};
export var ObservationKind;
(function (ObservationKind) {
    ObservationKind["Availability"] = "Availability";
    ObservationKind["Pricing"] = "Pricing";
})(ObservationKind || (ObservationKind = {}));
export var ObservationSource;
(function (ObservationSource) {
    ObservationSource["ContactWebForm"] = "ContactWebForm";
})(ObservationSource || (ObservationSource = {}));
export var EvergreenCommunityListingContactEnrollmentStatus;
(function (EvergreenCommunityListingContactEnrollmentStatus) {
    EvergreenCommunityListingContactEnrollmentStatus["Pending"] = "Pending";
    EvergreenCommunityListingContactEnrollmentStatus["Confirmed"] = "Confirmed";
    EvergreenCommunityListingContactEnrollmentStatus["Unsubscribed"] = "Unsubscribed";
})(EvergreenCommunityListingContactEnrollmentStatus || (EvergreenCommunityListingContactEnrollmentStatus = {}));
//# sourceMappingURL=community-contact.js.map